import { theme } from "@local-logic/core/ui";
import * as Accordion from "@radix-ui/react-accordion";
import { styled, keyframes } from "styled-components";

const slideDown = keyframes({
  from: { height: 0 },
  to: { height: "var(--radix-accordion-content-height)" },
});

const slideUp = keyframes({
  from: { height: "var(--radix-accordion-content-height)" },
  to: { height: 0 },
});

export const Header = styled(Accordion.Header)`
  margin: 0;
  z-index: 1;
  position: relative;
  margin: 0 calc(-1 * ${theme["--ll-spacing-medium"]});
  padding: 0 ${theme["--ll-spacing-medium"]};

  &:hover {
    background-color: ${theme["--ll-color-surface"]};
    box-shadow: ${theme["--ll-shadow-small"]};
  }
`;

export const Trigger = styled(Accordion.Trigger)`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${theme["--ll-spacing-x-small"]} 0;
`;

export const Content = styled(Accordion.Content)`
  background-color: ${theme["--ll-color-surface"]};
  position: relative;
  overflow: hidden;
  margin-left: calc(-1 * ${theme["--ll-spacing-medium"]});
  margin-right: calc(-1 * ${theme["--ll-spacing-medium"]});

  [data-state="open"] & {
    /* TODO: Re-implement this once StyledComponents is fixed. https://locallogic.atlassian.net/browse/LL22-1107 */
    /* animation: ${slideDown} 300ms cubic-bezier(0.87, 0, 0.13, 1); */
    visibility: visible;
  }

  [data-state="closed"] & {
    /* TODO: Re-implement this once StyledComponents is fixed. https://locallogic.atlassian.net/browse/LL22-1107 */
    /* animation: ${slideUp} 300ms cubic-bezier(0.87, 0, 0.13, 1); */
    visibility: hidden;
  }
`;

export const InnerContent = styled.div`
  padding: ${theme["--ll-spacing-medium"]};
  border-top: 1px solid ${theme["--ll-color-border"]};
  border-bottom: 1px solid ${theme["--ll-color-border"]};
`;

export const ChevronContainer = styled.span`
  ${Trigger}[data-state=open] & {
    transform: rotate(90deg);
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const POIContainer = styled.div`
  margin-top: ${theme["--ll-spacing-large"]};
  &:empty {
    margin: 0;
  }
`;

export const LoadingItemContainer = styled.div`
  margin: ${theme["--ll-spacing-small"]} 0;
`;
